import { ACTIVATION_USER } from "../../../api/apiRoutes";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { errorMessageFromApi } from "../../../utils/apiErrorMessages";

export default function useActivationUser() {
  const { get } = useApiRequest();
  const activateUser = async (token: string, ids: string) => {
    const response = await get(ACTIVATION_USER(token, ids));
    if (response?.isError) {
      return { ok: false, error: errorMessageFromApi(response) };
    }
    return { ok: true, error: "" };
  };

  return {
    activateUser,
  };
}
